import { FormattedMessage } from 'react-intl';
import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { LockIcon } from '@m/alchemy-ui/icons/LockIcon';
import { type IdeaStatusLabel, MODERATION_LABELS } from '../IdeaCard.types';
import * as Styled from './IdeaCard.styled';

interface IdeaLabelsProps {
  readonly moderationStatus: number;
  readonly statusLabels: IdeaStatusLabel[];
  readonly isHidden: boolean;
  readonly isPrivate: boolean;
}

export const IdeaLabels = ({ moderationStatus, statusLabels, isHidden, isPrivate }: IdeaLabelsProps) => {
  const moderationLabel = MODERATION_LABELS[moderationStatus];
  const hasStatusLabels = statusLabels && statusLabels.length > 0;
  const showLabels = !!moderationLabel || hasStatusLabels || isHidden || isPrivate;

  if (!showLabels) return null;

  return (
    <Styled.LabelWrap>
      {isPrivate && (
        <AlchemyTooltip
          trigger={
            <Styled.PrivateLabel>
              <LockIcon aria-hidden="true" />
              <FormattedMessage id="private" defaultMessage="Private" />
            </Styled.PrivateLabel>
          }
          placement="top"
          contents={
            <FormattedMessage id="privateIdeaTooltip" defaultMessage="Idea only visible to authors and moderators" />
          }
        />
      )}
      {isHidden && (
        <Styled.HiddenLabel>
          <FormattedMessage id="hidden" defaultMessage="Hidden" />
        </Styled.HiddenLabel>
      )}
      {moderationLabel && <Styled.StatusLabel>{moderationLabel.text}</Styled.StatusLabel>}
      {statusLabels?.map((status) => (
        <Styled.StatusLabel
          key={status.id}
          style={{ color: `#${status.textColor}`, backgroundColor: `#${status.color}` }}
        >
          {status.name}
        </Styled.StatusLabel>
      ))}
    </Styled.LabelWrap>
  );
};
